export const LOGIN_SCREEN = {
  WELCOME_BACK: 'Welcome back',
  SIGN_IN: 'Sign in',
  EMAIL: 'Email',
  PASSWORD: 'Password',
  FORGOT_PASSWORD: 'Forgot Password?',
  EMAIL_REQUIRED: 'Email is required',
  PASSWORD_REQUIRED: 'Password is required',
};
